<template>
  <c-box>
    <c-heading as="h1">{{ $t("dialog.forbiddenOperation.title", locale) }}</c-heading>
    <c-text>
      {{ $t("common.blockedInfo", locale) }}
    </c-text>
    <c-text>
      {{ $t("contact.contactPerson.title", locale) }}
    </c-text>
    <c-list>
      <c-list-item>{{ $router.currentRoute.query.repName }}</c-list-item>
      <c-list-item>{{ $router.currentRoute.query.repPhone }}</c-list-item>
      <c-list-item>
        <c-link :href="`mailto:${$router.currentRoute.query.repEmail}`">{{
          $router.currentRoute.query.repEmail
        }}</c-link>
      </c-list-item>
    </c-list>
    <c-text><c-link href="/logout">Back to login page</c-link></c-text>
  </c-box>
</template>

<script lang="ts">
import { CBox, CHeading, CLink, CList, CListItem, CText } from "@chakra-ui/vue";
import { defineComponent } from "vue";
import VueI18n from "vue-i18n";

export default defineComponent({
  name: "PartnerBlocked",
  components: {
    CHeading,
    CText,
    CBox,
    CLink,
    CList,
    CListItem,
  },
  computed: {
    locale() {
      return this.$router.currentRoute.query.locale as VueI18n.Locale;
    },
  },
});
</script>
